import { render, staticRenderFns } from "./KloosterNavLeft.vue?vue&type=template&id=7aa5c298&scoped=true"
import script from "./KloosterNavLeft.vue?vue&type=script&lang=js"
export * from "./KloosterNavLeft.vue?vue&type=script&lang=js"
import style0 from "./KloosterNavLeft.vue?vue&type=style&index=0&id=7aa5c298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa5c298",
  null
  
)

export default component.exports